import moment from "moment";
import axios from "axios";
import apiConfig from "../APIconfig/ApiConfig";

export const LANGUAGES = [
  { name: "English", value: "ENGLISH" },
  { name: "Hindi", value: "HINDI" },
  // { name: "Marathi", value: "MARATHI" },
  { name: "Bengali", value: "BENGALI" },
  // { name: "Telugu", value: "TELUGU" }
]

export function sortAddress(add) {
  const sortAdd = `${add?.slice(0, 6)}...${add?.slice(add.length - 4)}`;
  return sortAdd;
}

export function sortString(add) {
  const sortAdd = `${add?.slice(0, 6)}...${add?.slice(add.length - 10)}`;
  return sortAdd;
}

export function sortStringByLength(text, maxLength) {
  if (text.length <= maxLength) {
    return text;
  }
  const middle = Math.floor((maxLength - 3) / 2); // 3 accounts for the length of "..."
  return `${text.slice(0, middle)}...${text.slice(-middle)}`;
}

export const convertDateTime = (val) => {
  var tempDate = new Date(val);
  const toDateFormat = moment(tempDate).format("DD-MMM-yyyy hh:mm a");
  return toDateFormat;
};
export const handleFileRead = async (event) => {
  const file = event.target.files[0];
  const base64 = await convertBase64(file);
  return base64;
  // setImgDef(base64);
  // console.log("base64--->", base64);
};
export const DataURIToBlob = (dataURI) => {
  const splitDataURI = dataURI.split(",");
  const byteString =
    splitDataURI[0].indexOf("base64") >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

  return new Blob([ia], { type: mimeString });
};
const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};
export const putAPIdata = async ({ params, data, endPoint, headers }) => {
  console.log(params, data, endPoint);
  console.log("data888---->", data);
  try {
    let res;

    res = await axios({
      url: endPoint,
      method: "POST",
      params: params,
      data: data,
      headers: headers,
    })
      .then((res) => {
        console.log("ressdas--->", res);
        if (res?.data?.responseCode === 200) {
          //toast.success(res?.data?.message)
          return res;
        }
        if (res?.data?.status === 400) {
          //toast.error(res?.data?.message)
          return false;
        }
        if (res?.data?.status === 401) {
          //toast.error(res?.data?.message)
          return false;
        }
      })
      .catch((error) => {
        //toast.error(error.response.message)
        return false;
      });
    return res;
  } catch (error) {
    return false;
  }
};
export const fileToBase64 = (filename, filepath) => {
  return new Promise((resolve) => {
    var file = new File([filename], filepath);
    var reader = new FileReader();
    // Read file content on file loaded event
    reader.onload = function (event) {
      resolve(event.target.result);
    };

    // Convert data to base64
    reader.readAsDataURL(file);
  });
};

export const handleSessionExpiration = () => {
  console.log("Session expired - logging out");
  // Clear all auth tokens
  window.sessionStorage.removeItem("token");
  window.localStorage.removeItem("creatturAccessToken");
  window.localStorage.removeItem("userType");
  
  // Clear any axios headers
  delete axios.defaults.headers.common.Authorization;
  delete axios.defaults.headers.common.token;
  
  // Force redirect to login page
  window.location.href = "/login";
};

export const checkTokenValidity = async () => {
  const token = window.sessionStorage.getItem("token");
  if (!token) {
    handleSessionExpiration();
    return false;
  }
  
  try {
    // Make a lightweight API call to verify token is still valid
    const response = await axios({
      method: "GET",
      url: apiConfig.getProfile,
      headers: {
        token: token,
      },
      timeout: 5000 // Add timeout to handle network issues
    });
    
    // Check for valid response code
    if (response?.data?.responseCode !== 200) {
      handleSessionExpiration();
      return false;
    }
    
    return true;
  } catch (error) {
    console.log("Token validation failed:", error.message || "Unknown error");
    // Clear session for any error (network, auth, etc.)
    handleSessionExpiration();
    return false;
  }
};
